import { render, staticRenderFns } from "./Disclamer.vue?vue&type=template&id=9e43dfbe&scoped=true"
import script from "./Disclamer.vue?vue&type=script&lang=js"
export * from "./Disclamer.vue?vue&type=script&lang=js"
import style0 from "./Disclamer.vue?vue&type=style&index=0&id=9e43dfbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e43dfbe",
  null
  
)

export default component.exports